import { DocumentPickerAsset } from "expo-document-picker";
import { ComponentProps, useCallback, useMemo } from "react";
import { SendProps } from "@kesha-antonov/react-native-chat";
import { Button } from "../../../../ui/button";
import Show from "../../../show";
import { MontuMessage } from "../../types";

type Props = Omit<SendProps<MontuMessage>, "children"> & {
  buttonProps: Omit<ComponentProps<typeof Button>, "isDisabled" | "onPress">;
  documentPicker?: DocumentPickerAsset | null;
};

export default function GiftedChatSend(props: Props) {
  const {
    text,
    onSend,
    isSendButtonAlwaysVisible,
    buttonProps,
    documentPicker,
  } = props;
  const isDisabled = useMemo(
    () => !text?.trim() && !documentPicker,
    [text, documentPicker],
  );
  const handleOnPress = useCallback(() => {
    !isDisabled &&
      onSend?.(
        {
          text: text?.trim(),
          document: documentPicker
            ? {
                uri: documentPicker.uri,
                name: documentPicker.name,
                mimeType: documentPicker.mimeType || "",
              }
            : undefined,
        },
        true,
      );
  }, [text, onSend, isDisabled, documentPicker]);
  const showSend = useMemo(
    () =>
      Boolean(isSendButtonAlwaysVisible || (text && text.trim().length > 0)),
    [isSendButtonAlwaysVisible, text],
  );
  return (
    <Show when={showSend}>
      <Button
        {...buttonProps}
        onPress={handleOnPress}
        isDisabled={isDisabled}
      />
    </Show>
  );
}
